import { AboutSection } from '../../features/AboutSection'
import { BenefitsSection } from '../../features/BenefitsSection'
import { ContactSection } from '../../features/ContactSection'
import { DetailsSection } from '../../features/DetailsSection'
import { FeaturesSection } from '../../features/FeaturesSection'
import { GallerySection } from '../../features/GallerySection'
import { HeroSection } from '../../features/HeroSection'
import { StickyHeader } from '../../shared/ui/StickyHeader'

export const MainPage = () => {
    return (
        <>
            <StickyHeader
                onPrimaryCtaClick={() => {
                    document
                        .getElementById('main-hero')
                        ?.scrollIntoView({ behavior: 'smooth' })
                }}
            />
            <HeroSection />
            <BenefitsSection />
            <GallerySection />
            <DetailsSection />
            <AboutSection />
            <FeaturesSection />
            <ContactSection />
        </>
    )
}
